var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29002 0.710469C1.68002 0.320469 2.31002 0.320469 2.70002 0.710469L7.29002 5.30047C7.68002 5.69047 7.68002 6.32047 7.29002 6.71047L2.70002 11.3005C2.31002 11.6905 1.68002 11.6905 1.29002 11.3005C0.90002 10.9105 0.90002 10.2805 1.29002 9.89047L5.17002 6.00047L1.29002 2.12047C0.90002 1.73047 0.910019 1.09047 1.29002 0.710469Z",
    fill: "#1A1A1A",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightNav);
export default __webpack_public_path__ + "static/media/rightNav.b56161c366a12c289eff08ea31083c99.svg";
export { ForwardRef as ReactComponent };